import { Check, Globe } from "@phosphor-icons/react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// One picker for the website and the console: a small pill with the current code ("EN") that opens a compact list of the
// server's languages (current one checked). The list scrolls after about five rows, so new languages need no code change.
const LOOK = {
  site: {
    pill: "s-focus border border-[var(--s-line)] bg-[var(--s-card)] text-[var(--s-text)] hover:border-[var(--s-coral-2)]",
    menu: "border-[var(--s-card-border)] bg-[var(--s-card)] text-[var(--s-text)] shadow-[var(--s-shadow)]",
    item: "focus:bg-[var(--s-chip)] focus:text-[var(--s-text)]",
    muted: "s-muted",
  },
  console: {
    pill: "border border-border bg-white cw-soft hover:text-foreground",
    menu: "border-border bg-white",
    item: "focus:bg-[var(--cw-surface-tertiary)]",
    muted: "cw-muted",
  },
};

export default function LanguagePicker({ value, languages, onChange, variant = "site", testId = "language-picker", align = "end", side }) {
  const look = LOOK[variant];
  const items = languages?.length ? languages : [{ code: "en", native_name: "English" }];
  const code = (value || "en").toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label="Language" className={`inline-flex h-9 items-center gap-1.5 rounded-full px-2.5 text-xs font-semibold tracking-wide transition-colors cw-ease focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--cw-brand,#F26C50)] sm:px-3 ${look.pill}`} data-testid={testId}>
          <Globe size={14} aria-hidden className="hidden sm:block" /><span data-no-i18n>{code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} side={side} className={`max-h-[13.25rem] min-w-[11rem] overflow-y-auto rounded-2xl p-1.5 ${look.menu}`} data-testid={`${testId}-menu`}>
        {items.map((l) => {
          const on = l.code === value;
          return (
            <DropdownMenuItem key={l.code} onSelect={() => !on && onChange(l.code)} className={`flex h-10 cursor-pointer items-center gap-3 rounded-xl px-3 text-sm ${look.item}`} data-testid={`${testId}-option-${l.code}`} data-no-i18n>
              <span className={`w-6 text-xs font-semibold ${on ? "" : look.muted}`}>{l.code.toUpperCase()}</span>
              <span className={`flex-1 ${on ? "font-semibold" : ""}`}>{l.native_name || l.english_name || l.code}</span>
              {on && <Check size={15} weight="bold" className="text-[#F26C50]" aria-label="Current" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
